import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { ActivatedRoute } from '@angular/router';
import { Dashboard } from 'app/models/dashboard';
import { DashboardService } from 'app/services/dashboard.service';
import { finalize } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ValidationHandler } from 'app/helpers/validation.handler';
import * as _ from "lodash";
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent implements OnInit, AfterViewInit {

  tags: Tag[];
  filterTags: Tag[] = [];

  dashboardNamesFilter: string[] = [];
  
  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  dashboards: Dashboard[] = [];
  unfilteredDashboards: Dashboard[] = [];

  isNgSelectLoading: boolean = false;
  isAddingDashboard: boolean = false;
  isDeleting: boolean = false;

  addEditDashboardFormGroup: FormGroup = null;
  dashboardToDelete: Dashboard = null;
  
  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('addEditDashboardModal') addEditDashboardModal: ModalDirective;
  @ViewChild('deleteConfirmationModal') deleteConfirmationModal: ModalDirective;

  constructor(public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService,
              private activatedRoute: ActivatedRoute, private dashboardService: DashboardService,
              private validationHandler: ValidationHandler, public userService: UserService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle( 'Manage Dashboards', false );
    
    this.tableLoadingIndicator = true;
    this.dashboardService.currentDashboardsSubject.subscribe((d) => {
      this.dashboards = d;
      this.unfilteredDashboards = d;
      this.updateFilter();
      this.tableLoadingIndicator = false;
    });

    this.tagService.currentTagsSubject.subscribe(t => this.tags = t);
  }
  
  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const action = queryParams['action']? queryParams['action']: '';
  
      if (action == 'createNewDashboard') {
        setTimeout(() => {
          this.onAddNewDashboardClick();          
        }, 1);
      }
    });    
  }  

  innerWidth() {
    return window.innerWidth;
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  onAddNewDashboardClick() {
    this.addEditDashboardFormGroup = this.dashboardService.formGroup();
    this.addEditDashboardModal.show();
  }

  onFinishedAddEditDashboard() {
    this.validationHandler.onSubmitCheck(this.addEditDashboardFormGroup);
    if (!this.addEditDashboardFormGroup.valid) {
      return;
    }

    this.isAddingDashboard = true;
    this.dashboardService.put(this.addEditDashboardFormGroup.value).pipe(finalize(()=>{
      this.isAddingDashboard = false;
    })).subscribe(() => {
      this.addEditDashboardModal.hide();
      this.addEditDashboardFormGroup = null;
    });
  }

  editDashboard(d: Dashboard) {
    this.addEditDashboardFormGroup = this.dashboardService.formGroup(d);
    this.addEditDashboardModal.show();
  }

  deleteDashboard() {
    this.isDeleting = true;
    this.dashboardService.delete(this.dashboardToDelete.id).pipe(finalize(() => {
      this.isDeleting = false;
      this.deleteConfirmationModal.hide();
    })).subscribe();
  }

  updateFilter() {
    // filter our data
    const temp = this.unfilteredDashboards.filter((dashboard: Dashboard) => {

      return (this.dashboardNamesFilter.length == 0 || this.dashboardNamesFilter.indexOf(dashboard.name) != -1)
        &&
        (this.filterTags.length == 0 || _.intersectionWith(this.filterTags, dashboard.tags, (a, b)=>{return a.name == b.name}).length > 0);
    });

    // update the rows
    this.dashboards = temp;

    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }
}
